<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main pb-5">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-3 font-weight-black">Agregar categoría</h1>
                  <v-btn color="grey" outlined dark to="/admin/categorias">
                    <v-icon left>keyboard_backspace</v-icon>Regresar a
                    categorias
                  </v-btn>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-12">
                <v-text-field
                  label="Nombre de la categoría"
                  placeholder="nombre"
                  outlined
                  v-model="nombre"
                />

                <v-btn large color="primary" @click="validar()"
                  >Agregar categoría</v-btn
                >
              </div>
            </div>
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import router from "@/router";
export default {
  data() {
    return {
      error: "",
      nombre: "",
      loader: false,
    };
  },
  methods: {
    validar() {
      if (this.nombre == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Ingresa el nombre de la categoría",
          showConfirmButton: true,
        });
      } else {
        //Los datos requeridos se ingresaron
        this.guardar();
      }
    },

    guardar() {
      this.loader = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=saveCategoria" +
            "&nombre=" +
            this.nombre
        )
        .then((response) => {
          this.$swal({
            type: "success",
            title: "La categoría se creó exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });

          setTimeout(
            () =>
              router.push({
                name: "categorias_admin",
              }),
            1500
          );
        })
        .catch((error) => console.log(error));
    },
  },
  mounted() {},
};
</script>
